
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreatePersonnelFileEntryDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    categoryId: new FormControl<number | undefined>(undefined, [Validators.required]),
    subject: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(250)]),
    notes: new FormControl<string | undefined>(undefined),
    entryDate: new FormControl<string | undefined>('', [Validators.required]),
    confidential: new FormControl<boolean | undefined>(true),
})
;
}
      